/* global SideDrawer */

function debounce(fn, delay) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), delay);
  };
}

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
    this.scheduleSyncPriceCol = debounce(() => {
      this.syncCartDrawerPriceColumnWidth();
    }, 120);
    this.boundResizeSync = () => {
      if (this.hasAttribute('open')) this.scheduleSyncPriceCol();
    };
    window.addEventListener('resize', this.boundResizeSync, { passive: true });
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart-drawer:after-open', () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.syncCartDrawerPriceColumnWidth());
      });
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      requestAnimationFrame(() => this.syncCartDrawerPriceColumnWidth());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    window.removeEventListener('resize', this.boundResizeSync);
  }

  /**
   * 移动端：根据当前购物车所有行的单价区块最大「内容宽度」设置右侧列宽（CSS 变量），
   * 避免固定 minmax 造成短标题与金额之间留白过大；桌面端清除变量。
   */
  syncCartDrawerPriceColumnWidth() {
    if (!window.matchMedia('(max-width: 767.98px)').matches) {
      this.style.removeProperty('--cart-drawer-price-col');
      return;
    }

    const prices = this.querySelectorAll('.cart-item .cart-item__column.cart-item__price');
    if (!prices.length) {
      this.style.removeProperty('--cart-drawer-price-col');
      return;
    }

    let maxW = 0;
    prices.forEach((el) => {
      const wrap = el.closest('.cart-item__not-image');
      if (!wrap) return;
      const clone = el.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.style.cssText = [
        'position:absolute',
        'left:-9999px',
        'top:0',
        'width:max-content',
        'max-width:none',
        'visibility:hidden',
        'pointer-events:none',
        'height:auto'
      ].join(';');
      wrap.appendChild(clone);
      const w = clone.getBoundingClientRect().width;
      maxW = Math.max(maxW, w);
      clone.remove();
    });

    const px = Math.ceil(maxW + 2);
    const clamped = Math.min(120, Math.max(44, px));
    this.style.setProperty('--cart-drawer-price-col', `${clamped}px`);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
